import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Role Management Service
 * !== 역할 관리 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/ptl/auth-menu`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/auth-menu/auth-menu`,
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli1015001q: `${BASE.path}/ptli1015001q`, // Select. Auth and Menu Link List
    ptli1015002s: `${BASE.path}/ptli1015002s`, // Save. Auth and Menu Link
    ptli1015003q: `${BASE.path}/ptli1015003q`, // Popup. Auth and Menu Link List
};

export const PGEUIDS = {
    ptli1015001q: "ptli1015001q",
    ptli1015002s: "ptli1015002s",
    ptli1015003q: "ptli1015003q",
    ptli1015004q: "ptli1015004q",
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Select Menu List !== 메뉴 목록 조회 ==!
    getMenuList: (data: any) => api.get(`${BASE.api}/menu`, { params: comnUtils.toGetParams(data) }),

    // Select Screen List !== 화면 목록 조회 ==!
    getScrnList: (data: any) => api.get(`${BASE.api}/scrn`, { params: comnUtils.toGetParams(data) }),

    // Select Auth and Menu Link Detail !== 권한 및 메뉴 연결 상세 조회 ==!
    getAuthMenuDtl: (data: any) =>
        api.get(`${BASE.api}/${data.authId}`, {
            params: comnUtils.toGetParams({ bsopClsfCd: data.bsopClsfCd, ptlTpCd: data.ptlTpCd }),
        }),

    // Save Auth and Menu Link Detail !== 권한 및 메뉴 연결 상세 저장 ==!
    saveAuthMenuDtl: (data: any) => api.post(`${BASE.api}/${data.authId}`, { ...data }),
};

export const SF_AUTH_DTL: TFormSchema = {
    id: "form_authDtl",
    schema: {
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            edit: false,
            area: "comnCd",
            comnCd: "COM0024",
            excludes: ["COM"],
        },
        ptlTpCd: {
            type: "select",
            label: "L_PTL_TP_CD",
            edit: false,
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
        },
        authId: { type: "text", label: "L_AUTH_ID", edit: false },
        authNm: { type: "text", label: "L_AUTH_NM", edit: false },
        authDesc: { type: "text", label: "L_AUTH_DESC", edit: false },
    },
};

export const SF_MENU_SRCH: TFormSchema = {
    id: "form_menuSrch",
    schema: {
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "COM0024",
            excludes: ["COM"],
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
        },
        menuId: { type: "text", label: "L_MENU_ID" },
        menuNm: { type: "text", label: "L_MENU_NM" },
    },
};

export const SG_AUTH_MENU_LIST: TGridSchema = {
    id: "grid_authMenuList",
    options: { checkbox: true, pagination: "in", index: true },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: "*" }], show: false },
        { cells: [{ header: "L_PTL_TP_CD", binding: "ptlTpCd", width: "*" }], show: false },
        { cells: [{ header: "L_AUTH_ID", binding: "authId", width: "*" }], show: false },
        { cells: [{ header: "L_MENU_ID", binding: "menuId", width: "*" }] },
        { cells: [{ header: "L_MENU_NM", binding: "menuNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCd" }] },
        { cells: [{ binding: "ptlTpCd" }] },
        { cells: [{ binding: "authId" }] },
        { cells: [{ binding: "menuId" }] },
        { cells: [{ binding: "menuNm", align: "left" }] },
    ],
};

export const SG_MENU_LIST: TGridSchema = {
    id: "grid_menuList",
    options: { checkbox: true, index: true, pagination: "in" },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: "*" }], show: false },
        { cells: [{ header: "L_PTL_TP_CD", binding: "ptlTpCd", width: "*" }], show: false },
        { cells: [{ header: "L_MENU_ID", binding: "menuId", width: "*" }] },
        { cells: [{ header: "L_MENU_NM", binding: "menuNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCd" }] },
        { cells: [{ binding: "ptlTpCd" }] },
        { cells: [{ binding: "menuId" }] },
        { cells: [{ binding: "menuNm", align: "left" }] },
    ],
};
export const SG_SCRN_LIST: TGridSchema = {
    id: "grid_scrnList",
    options: { index: true, pagination: "in" },
    head: [
        { cells: [{ header: "L_SCRN_ID", binding: "scrnId", width: "*" }] },
        { cells: [{ header: "L_SCRN_NM", binding: "scrnNm", width: "*" }] },
    ],
    body: [{ cells: [{ binding: "scrnId" }] }, { cells: [{ binding: "scrnNm", align: "left" }] }],
};
